export const config = {
  apiEndpoint: import.meta.env.VITE_API_ENDPOINT ?? 'https://ferq9pxsh1.execute-api.ap-northeast-1.amazonaws.com/prod',
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? 'ap-northeast-1_tKBynCo6F',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? '4n0ljq530penfr4133ng82h7mm',
  },
};
